import { encode } from 'uqr';

import { cn } from '../lib/cn.ts';

/**
 * QR-код как SVG (для приложения-аутентификатора и ссылок на телефон).
 * Всегда тёмные модули на белом с полем: так его читают камеры и в тёмной теме.
 */
export function QrCode({ value, label, className }: { value: string; label: string; className?: string }) {
  const { data, size } = encode(value, { ecc: 'M', border: 2 });
  let path = '';
  data.forEach((row, y) => {
    row.forEach((dark, x) => {
      if (dark) path += `M${String(x)} ${String(y)}h1v1h-1z`;
    });
  });
  return (
    <svg
      viewBox={`0 0 ${String(size)} ${String(size)}`}
      role="img"
      aria-label={label}
      shapeRendering="crispEdges"
      className={cn('rounded-md bg-white', className)}
    >
      <path d={path} fill="#0d0d0d" />
    </svg>
  );
}
